import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import DashboardRedirectMiddleware from '../middleware/DashboardRedirectMiddleware';

const MainLayout = () => {
  return (
    <div className="app-container">
      {/* Middleware para interceptar e redirecionar acessos indevidos ao dashboard */}
      <DashboardRedirectMiddleware />
      
      <Sidebar />
      
      <div className="main-content">
        <Header />
        <div className="content-wrapper">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;